module.exports = __webpack_public_path__ + "images/b59d7a8476253c688166c55af7b8ffb5.png";